import type { AppRules, UploadCategory } from "./types";

export const uploadCategories: UploadCategory[] = [
  {
    id: "productMap",
    label: "对应表",
    hint: "产品基础信息、ASIN、SKU、落地成本",
    accept: ".xlsx,.xls",
    multiple: false,
    required: true
  },
  {
    id: "allOrder",
    label: "ALL ORDER",
    hint: "订单明细，支持 Amazon txt/tab/csv/xlsx；此项不限制文件选择器类型",
    accept: "",
    multiple: true,
    required: true
  },
  {
    id: "feePreview",
    label: "FEE PREVIEW",
    hint: "按文件适用日期范围匹配配送费",
    accept: ".csv,.xlsx,.xls",
    multiple: true,
    required: false
  },
  {
    id: "spAds",
    label: "SP 广告",
    hint: "Sponsored Products advertised product report",
    accept: ".xlsx,.xls,.csv",
    multiple: true,
    required: false
  },
  {
    id: "sbAds",
    label: "SB 广告",
    hint: "Sponsored Brands campaign report",
    accept: ".xlsx,.xls,.csv",
    multiple: true,
    required: false
  },
  {
    id: "sdAds",
    label: "SD 广告",
    hint: "Sponsored Display advertised product report",
    accept: ".xlsx,.xls,.csv",
    multiple: true,
    required: false
  },
  {
    id: "storageFee",
    label: "STORAGE FEE",
    hint: "月仓储费，缺月时向前取最近月份",
    accept: ".xlsx,.xls,.csv",
    multiple: true,
    required: false
  },
  {
    id: "transaction",
    label: "TRANSACTION",
    hint: "结算交易，实收配送费、佣金、退款、调整",
    accept: ".xlsx,.xls,.csv",
    multiple: true,
    required: false
  },
  {
    id: "customerReturn",
    label: "CUSTOMER RETURN",
    hint: "买家退货，SELLABLE 返还落地成本",
    accept: ".xlsx,.xls,.csv",
    multiple: true,
    required: false
  }
];

export const defaultRules: AppRules = {
  commissionRate: 0.15,
  peakMonths: [10, 11, 12],
  peakMultiplier: 3,
  sbSkuDelimiter: "-sb",
  timezone: "America/Los_Angeles"
};
